module.exports = __webpack_public_path__ + "static/media/siegener-logo.244c86ef.png";